import type { TypedMyBrandPromises } from './-MyBrandPromises';
import RawMyBrandPromises from './MyBrandPromises.vue';
export * from './-MyBrandPromises';
export const MyBrandPromises = RawMyBrandPromises as typeof TypedMyBrandPromises;
